import { Formik } from 'formik';
import React from 'react';
import { useRecoilValueLoadable, useSetRecoilState } from 'recoil';
import cookie from 'react-cookies';
import { agentUserId } from '../../../recoil/atoms/agentUserId';
import { ModalWithStyles } from './ModalWithStyles';
import axios from '../../../common/axiosInterceptor';
import querystring from 'querystring';
import { useHistory } from 'react-router-dom';
import { refetchToggle } from '../../../recoil/selectors/makePHPRequest';
import { endpointEnum } from '../../../services/rest/makeAPIRequest';

export function DeleteAgentModal({
  show,
  handleClose,
  name,
  enqueueSnackbarWithStyles,
  userAtom,
}) {
  const history = useHistory();
  const currentUser = useRecoilValueLoadable(agentUserId);
  const setRefetchToggleForAgents = useSetRecoilState(
    refetchToggle(endpointEnum.GET_BUSINESS_USERS)
  );
  const setRefetchToggleForTeamSettings = useSetRecoilState(
    refetchToggle(endpointEnum.GET_TEAM_SETTINGS)
  );
  const setRefetchToggleForBusinessTeams = useSetRecoilState(
    refetchToggle(endpointEnum.GET_BUSINESS_TEAMS)
  );
  return (
    <Formik
      onSubmit={async (values, actions) => {
        const url =
          `${process.env.VITE_APP_PHP_DOMAIN}/rest/functions.php?` +
          querystring.stringify({
            call: 'webUpdateKixieManagerDeleteUser',
            loggedinuser: userAtom.contents.userid,
            businessid: userAtom.contents.businessid,
            userid: currentUser.contents.id,
            apiKey: userAtom.contents.apikey,
          });
        const accessToken = cookie.load('accessToken');
        const result = await axios.post(url, null, {
          withCredentials: true,
          headers: {
            authorization: accessToken,
          },
        });
        if (result?.data?.meta?.success) {
          enqueueSnackbarWithStyles({
            message: 'Successfully Deleted Agent',
            alertProps: { severity: 'success' },
          });
        }
        setRefetchToggleForAgents({});
        setRefetchToggleForTeamSettings({});
        setRefetchToggleForBusinessTeams({});
        handleClose();
        history.push('/manage/agents');
        // const response = await makeRequest({
        //   methodName: methodNameEnum.INACTIVATE_AGENT,
        //   payload: {
        //     userid: currentUser.contents.userid,
        //     loggedinuser: userAtom.contents.id,
        //     businessid: userAtom.contents.businessid,
        //   },
        // });
        actions.resetForm({});
      }}
      enableReinitialize={true}
      initialValues={{
        name: name,
      }}
    >
      {(formik) => (
        <ModalWithStyles
          onSubmit={formik.handleSubmit}
          title={`Delete Agent ${formik.values.name}`}
          aria-labelledby="example-modal-sizes-title-md"
          show={show}
          onHide={handleClose}
          isSubmitting={formik.isSubmitting}
          deleteDialog={true}
        >
          <p>
            Please note that there are no refunds for deleting users. If you
            want to replace this user, use the save/replace button instead.
          </p>
          <p>
            You are about to delete the Agent <b> {formik.values.name}</b>, this
            procedure is not reversible.
          </p>
          <p>Do you want to proceed?</p>
        </ModalWithStyles>
      )}
    </Formik>
  );
}
